import React from "react";
import styled, { keyframes } from "styled-components";
import "./css/loader.css";

function LoadingSpiner(props) {
  if (props.active) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }
  return <div />;
}
const rotate360 = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;
const LoaderContainer = styled.div`
  width: 100%;
  margin: 1rem 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Loader = styled.div`
  width: 60px;
  height: 60px;

  border-radius: 100%;

  border-top: 3px solid #33cc99;
  border-right: 3px solid transparent;
  animation: ${rotate360} 1s linear infinite;
`;

export default LoadingSpiner;



// WEBPACK FOOTER //
// ./src/LoadingSpiner.jsx